<script>
import Speaker from 'gkConUI/con-speaker'
import utils from '@/utils'
import { mapState } from 'vuex'
export default {
  components: {
    Speaker
  },
  props: ['id'],
  data () {
    return {}
  },
  computed: {
    ...mapState({
      config: 'config',
      speakers: 'speakers'
    }),
    speaker () {
      return this.speakers[this.id] || {}
    }
  },
  updated () {
    utils.weixinshare({
      imgUrl: this.speaker.avatar,
      title: this.speaker.name + this.config.wechat_share.default_title
    })
  },
  mounted () {
    if (this.speaker.avatar) {
      utils.weixinshare({
        imgUrl: this.speaker.avatar,
        title: this.speaker.name + this.config.wechat_share.default_title
      })
    }
  },
  render () {
    return (<Speaker {...{ props: { id: this.id } }}/>)
  }
}
</script>
